import { useNavigate } from 'react-router-dom';
import { getCopilotValueByTaskIdApi } from '@/api/copilot';
import { useAuth } from '@/contexts/AuthContext';
import useUserStore from '@/stores/userStore';
import { NeedWaitResponse } from '@/stores/types/copilotValue';
import { toast } from 'sonner';
interface UseFunctionButtonsReturn {
  handleDiagnosis: () => void;
  handleCustomAssetAllocation: () => void;
  handleRiskAssessment: () => void;
}

/**
 * FunctionButtons 组件的导航和状态管理逻辑
 */
export function useFunctionButtons(): UseFunctionButtonsReturn {
  const { taskId } = useUserStore();
  const navigate = useNavigate();
  const { externalUserId, followUserId } = useAuth();

  // 持仓深度诊断
  const handleDiagnosis = () => {
    navigate('/aiAdvisorDiagnosis');
  };

  // 定制资产配置
  const handleCustomAssetAllocation = () => {
    if (!taskId) {
      toast.error('没有taskId，请先稍后重试');
      return;
    }
    getCopilotValueByTaskIdApi({
      externalUserId,
      reqType: 4,
      taskId,
      followUserId
    }).then(res => {
      navigate('/aiAdvisorCustomAssetAllocation', {
        state: { hasData: (res as NeedWaitResponse).status !== 'false' }
      });
    });
  };

  // AI投顾洞察
  const handleRiskAssessment = () => {
    navigate('/aiAdvisorRiskAssessment');
  };

  // 检查定制资产配置数据状态
  // useEffect(() => {
  //   if (taskId) {
  //     getCopilotValueByTaskIdApi({
  //       externalUserId,
  //       reqType: 4,
  //       taskId,
  //       followUserId
  //     }).then(res => {
  //       setAiAdvisorCustomAssetAllocation((res as NeedWaitResponse).status !== 'false');
  //     });
  //   }
  // }, [taskId]);

  return {
    handleDiagnosis,
    handleCustomAssetAllocation,
    handleRiskAssessment
  };
}
